import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CheckboxModule } from '@gosuite/checkbox';

import { NeoFrameComponent } from './neo-frame.component';
import { PlatTopMenuModule } from '../layout/components/platTopMenu/platTopMenu.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		PlatTopMenuModule,
		CheckboxModule,
	],
	declarations: [ NeoFrameComponent ],
	exports: [ NeoFrameComponent ],
})
export class NeoFrameModule {}



// WEBPACK FOOTER //
// ./src/app/neo-frame/neo-frame.module.ts